export default __webpack_public_path__ + "static/media/video.5e99e701.mp4";